<template>
  <div>
      <div :id="`pdf_page_${page.pageNumber}`"
        v-for="(page, index) in pages">
        <PDFPageSingle
          :page="page"
          :key="index"
        />
      </div>
  </div>
</template>

<script>
import PDFPageSingle from './PDFPageSingle';
export default {
  name: 'PDFDocumentShow',

  components: {
    PDFPageSingle,
  },

  props: {
    pages: {
      required: true,
    }
  },

  data() {
    return {
    }
  },

  mounted() {
  },
  beforeDestroy() {
  },

  watch: {
  },
  computed: {
  },

  methods: {
  },
};
</script>

<style lang="scss">
  .pdf-page {
    border: none!important;
    box-shadow: none!important;
  }
</style>
